import { Component } from '@angular/core';
import { ModalContent } from '@capital-access/firefly/components';

@Component({
  templateUrl: 'record-source-explanation-modal.component.html',
  standalone: false
})
export class RecordSourceExplanationModalComponent implements ModalContent {
  context!: {
    snpResearch: string;
    crm: string;
    snpCrm: string;
    snpResearchExplanation: string;
    snpCrmExplanation: string;
    crmExplanation: string;
  };
}
